<template>
  <div>
    <vx-card :title="$t('Filters')" class="mb-8" collapse-action>
      <div class="vx-row">
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm opacity-75">{{ $t("Search") }}</label>
          <vs-input :placeholder="$t('Code_ID_Iqama')" class="w-full mt-2" v-model="filters.keySearch" />
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm opacity-75">{{ $t("Nationality") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.NationalityId">
            <vs-select-item v-for="(item, index) in Nationalities" :key="index" :value="item.Id" :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" />
          </vs-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm opacity-75">{{ $t("InvestorCategory") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.InvestorCategoryId">
            <vs-select-item v-for="(item, index) in InvestorCategories" :key="index" :value="item.Id" :text="currentLocale === 'ar' ? item.NameAr : item.NameEn"  />
          </vs-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm opacity-75">{{ $t("KYCStatus") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.InvestorKycStatusId">
            <vs-select-item v-for="(item, index) in KycStatuses" :key="index" :value="item.Id" :text="currentLocale === 'ar' ? item.NameAr : item.NameEn" />
          </vs-select>
        </div>
        <div class="vx-col md:w-1/5 w-full">
          <label class="text-sm opacity-75">{{ $t("CanInvest") }}</label>
          <vs-select class="w-full mt-2" v-model="filters.CanInvest">
            <vs-select-item :value="true" :text="$t('Yes')" />
            <vs-select-item :value="false" :text="$t('No')" />
          </vs-select>
        </div>
      </div>
      <div class="vx-row mt-4">
        <div class="vx-col w-full flex justify-end">
          <vs-button color="danger" type="border" @click="resetAll">{{ $t("ResetSearch") }}</vs-button>
        </div>
      </div>
    </vx-card>

    <div id="data-list-list-view" class="data-list-container">
      <vs-table pagination :max-items="itemsPerPage" search :data="Investors">
        <template slot="thead">
          <vs-th sort-key="InvestorCode">{{ $t("Code") }}</vs-th>
          <vs-th sort-key="FullName">{{ $t("Name") }}</vs-th>
          <vs-th sort-key="NationalIdOrIqama">{{ $t("NationalID_Iqama") }}</vs-th>
          <vs-th>{{ $t("Category") }}</vs-th>
          <vs-th>{{ $t("KYCStatus") }}</vs-th>
          <vs-th>{{ $t("CanInvest") }}</vs-th>
          <vs-th>{{ $t("Actions") }}</vs-th>
        </template>

        <template slot-scope="{data}">
          <tbody>
            <tr v-for="(tr, indextr) in data" :key="indextr" @click="AddOrEditInvestor(tr)">
              <vs-td>{{ tr.InvestorCode }}</vs-td>
              <vs-td>{{ tr.UserFullNameAr }}</vs-td>
              <vs-td>{{ tr.NationalIdOrIqama }}</vs-td>
              <vs-td>{{ getCategoryName(tr.InvestorCategoryId) }}</vs-td>
              <vs-td><vs-chip :color="getKycColor(tr.InvestorKycStatusId)">{{ getKycStatusName(tr.InvestorKycStatusId) }}</vs-chip></vs-td>
              <vs-td>{{ tr.CanInvest ? $t('Yes') : $t('No') }}</vs-td>
              <vs-td class="whitespace-no-wrap">
                <div class="flex items-center">
                  
                  <feather-icon 
                    icon="EditIcon" 
                    svgClasses="w-5 h-5 hover:text-primary cursor-pointer" 
                    @click.stop="AddOrEditInvestor(tr)" 
                  />
                  
                  <vx-tooltip :text="tr.isActive ? $t('Block') : $t('Activate')" class="ml-2">
                      <feather-icon 
                        :icon="tr.IsActive ? 'UserXIcon' : 'CheckCircleIcon'" 
                        :svgClasses="['w-5 h-5 cursor-pointer', tr.IsActive ? 'hover:text-danger' : 'hover:text-success']" 
                        @click.stop="toggleActivation(tr)" 
                      />
                    </vx-tooltip>

                </div>
              </vs-td>
            </tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import VxCard from "../../components/vx-card/VxCard.vue";
import moduleInvestors from "@/store/Investors/moduleInvestors.js";
import moduleNationalities from "@/store/Nationality/moduleNationalities.js";
export default {
  components: { VxCard },
  data() {
    return {
      filters: {
        keySearch: "",
        NationalityId: null,
        InvestorCategoryId: null,
        InvestorKycStatusId: null,
        CanInvest: null
      },
      itemsPerPage: 10
    };
  },
  computed: {
    currentLocale() { return this.$i18n.locale; },
    Investors() { return this.$store.state.InvestorsList.Investors; },
    Nationalities() { return this.$store.state.NationalitiesList.Nationalities || []; },
    InvestorCategories() { return this.$store.state.InvestorsList.InvestorCategories || []; },
    KycStatuses() { return this.$store.state.InvestorsList.InvestorKYCStatus || []; }
  },
  methods: {
    toggleActivation(tr) {
  this.$vs.dialog({
    type: 'confirm',
    color: tr.isActive ? 'danger' : 'success',
    title: this.$t('Confirm'),
    text: `${this.$t('AreYouSureYouWantTo')} ${tr.isActive ? this.$t('Block') : this.$t('Activate')} ${tr.InvestorCode}?`,
    accept: () => {
      this.$vs.loading();
      this.$store.dispatch("InvestorsList/toggleInvestorStatus", tr.Id)
        .then((response) => {
          this.$vs.loading.close();

          tr.isActive = !tr.isActive;
          this.$vs.notify({ title: 'Success', text: response.data.Message, color: 'success' });
        })
        .catch(err => {
          this.$vs.loading.close();
          this.$vs.notify({ title: 'Error', text: 'Update failed', color: 'danger' });
        });
    }
  });
},
    resetAll() {
      this.filters = { keySearch: "", NationalityId: null, InvestorCategoryId: null, InvestorKycStatusId: null, CanInvest: null };
    },

     AddOrEditInvestor(data) {
    
      if (data.Id == undefined) {
          data.Id = 0;
      }

    
     this.$router.push(`/Investors/AddOrEditInvestor/${data.Id}`);
    },

    debouncedSearch() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.applyFilters();
    }, 500);
  },
  applyFilters() {
    this.$store.dispatch("InvestorsList/fetchFilteredInvestors", this.filters);
  },
    getKycColor(statusId) {
      if (statusId === 1) return "success";
      if (statusId === 2) return "warning";
      return "danger";
    },
    getCategoryName(id) {
       const item = this.InvestorCategories.find(x => x.Id === id);
       return this.currentLocale === 'ar' ? item.InvestorCategoryNameAr : item.InvestorCategoryNameEn;
    },
    getKycStatusName(id) {
       const item = this.KycStatuses.find(x => x.Id === id);
       return this.currentLocale === 'ar' ? item.InvestorKycStatusNameAr : item.InvestorKycStatusNameEn;
    },
    confirmDelete(tr) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('Confirm'),
        text: `${this.$t('AreYouSureDelete')} ${tr.InvestorCode}`,
        accept: () => this.deleteInvestor(tr.Id)
      });
    },
    deleteInvestor(id) {
      this.$vs.loading();
      this.$store.dispatch("InvestorsList/removeItem", id)
        .then(() => {
          this.$vs.loading.close();
          this.$vs.notify({ title: 'Success', text: 'Deleted Successfully', color: 'success' });
        })
        .catch(err => {
          this.$vs.loading.close();
          console.error(err);
        });
    }
  },
  watch: {

  filters: {
    handler() {
      this.debouncedSearch();
    },
    deep: true
  }
},
  created() {
    if (!moduleInvestors.isRegistered) {
      this.$store.registerModule("InvestorsList", moduleInvestors);
      moduleInvestors.isRegistered = true;
    }
    if (!moduleNationalities.isRegistered) {
      this.$store.registerModule("NationalitiesList", moduleNationalities);
      moduleNationalities.isRegistered = true;
    }
    this.$store.dispatch("InvestorsList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchInvestorCategories");
    this.$store.dispatch("InvestorsList/fetchInvestorKycStatus");
    this.$store.dispatch("NationalitiesList/fetchDataListItems");
    this.$store.dispatch("InvestorsList/fetchLookups"); 
  }
};
</script>

<style lang="scss">

 .icon-container{
    display: flex;
  }
#data-list-list-view small {
  color: rgb(255, 115, 0);
  text-decoration: underline rgb(255, 115, 0);
}

.vxCard:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0%;
  margin-left: 10%;
  z-index: 500000;
  width: 25%;
  height: 20%;
  border-top: 3px solid rgb(255, 115, 0) !important;
  border-bottom: 0 none rgba(255, 0, 0, 0.9) !important;
  border-right: 0 none rgba(255, 0, 0, 0.9) !important;
  border-left: 0 none rgba(0, 0, 0, 0.9) !important;
}
#data-list-list-view {
  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    .btn{
      margin-top: 5%;
    }
  }
}
</style>
